import React from 'react';
import PropTypes from 'prop-types';
import styles from './Badge.module.scss';

const Badge = ({ variant, size, children, className }) => {
  const classNames = [
    styles.badge,
    styles[variant],
    styles[size],
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return <span className={classNames}>{children}</span>;
};

Badge.propTypes = {
  variant: PropTypes.oneOf(['neutral', 'success', 'warning', 'danger', 'info']),
  size: PropTypes.oneOf(['sm', 'md']),
  children: PropTypes.node,
  className: PropTypes.string,
};

Badge.defaultProps = {
  variant: 'neutral',
  size: 'md',
  children: null,
  className: '',
};

export default Badge;
